import { render, staticRenderFns } from "./PptTool.vue?vue&type=template&id=17355191&"
import script from "./PptTool.vue?vue&type=script&lang=js&"
export * from "./PptTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptTool.vue"
export default component.exports